import React from 'react';
import strings from '../../../../globalization';
import styles from './SearchBox.module.css';
import searchImg from '../../../../assets/images/Fireboard/search.png';

const SearchBox = (props) => {
  const {
    searchValue,
    placeholder = strings.searchPlaceholder,
    onSearch = () => { }
  } = props || {};

  return (
    <div className={styles.textInputWrapper}>
      <input
        className={styles.textInput}
        type="text"
        value={searchValue}
        onChange={onSearch}
        placeholder={placeholder}
      />
      <button
        type="submit"
        className={styles.searchBtn}
      >
        <img src={searchImg} className={styles.searchImage} alt="" />
      </button>
    </div>
  );
}

export default SearchBox;
